export default class VoucherCreateRequest {
    constructor(locale, supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: '&nbsp',
            };
        });
    }

    static assign(from, to) {
        if (from) {
            to.title = from.title;
            to.locale = from.locale;
        } else {
            to = new VoucherCreateRequest();
        }
    }

    static copy(from) {
        const to = new VoucherCreateRequest();
        VoucherCreateRequest.assign(from, to);
        return to;
    }
}
